var FilterWithIcons = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

/**
 * Init'ing our filter
 * @return {[type]} [description]
 */
FilterWithIcons.prototype.init = function(){

  if(window.Breakpoint.value == "xsmall" || window.Breakpoint.value == "small"){
    this.initDropdown();
  }

};

/**
 * Initing our dropdown
 * @return {[type]} [description]
 */
FilterWithIcons.prototype.initDropdown = function(){

  var self = this;

  var height = this.options.$el.height()
  this.options.$el.attr("data-height", height);

  if(! this.options.$el.hasClass("open-on-mobile")){
    this.options.$el.height(30);
  }else{
    this.options.$el.addClass("is-open");
    this.options.$el.height(height);
  }

  this.options.$el.addClass("enable-dropdown");

  this.options.$el.find(".section-title-container").on("click", function(){
    self.toggle();
  });

}

/**
 * opening and closing
 * @return {[type]} [description]
 */
FilterWithIcons.prototype.toggle = function(){

  if(this.options.$el.hasClass("is-open")){
    this.options.$el.height(30);
    this.options.$el.removeClass("is-open");
  }else{
    var height = this.options.$el.data("height");
    this.options.$el.height(height);
    this.options.$el.addClass("is-open");
  }

};

export default  FilterWithIcons;
